export const BRAND_REQUEST_STATUSES = {
    /** 0: Deleted/ignored */
    IGNORED: 0,
    /** 1: Completed (not used atm) */
    CONFIRMED: 1,
    /** -1: Just created (initial state after CSV upload) */
    CREATED: -1,
    /** -2: The user didn't find a matching brand and he wants to create a new one. This value should be set from the UI when there's at least one logoversion uploaded and the brand is ticked. */
    NEW: -2
}
export const LOGO_VERSION_REQUEST_STATUSES = {
    /** 0: Deleted -> change to this value when the logoversion is unticked */
    DELETED: 0,
    /** 1: Completed */
    COMPLETED: 1,
    /** -2: Checked (ticked) logo version -> it will be activated on "complete" */
    CHECKED: -2
}

/** @enum {number} */
export const BRAND_REQUEST_GROUP_STATUSES = {
    /** -3: Status is set by frontend when there are no items to be processed */
    USER_DONE: -3,
    /** -2: CSV file uploaded */
    CSV_UPLOAD_COMPLETE: -2,
    /** -1: Just created (no csv file uploaded yet) */
    NO_CSV_UPLOADED: -1,
    /** 0: Request deleted */
    DELETED: 0,
    /** 1: Finished (all the brand requested has been activated and, in case, created). This is set by the server only. */
    FINISHED: 1    
}

export const BRAND_REQUEST_BRAND_STATUSES = {
    /** -1: Just created (initial state) */
    CREATED: -1,
    /** -2: Selected by the user from Similar Brands. Only one record per BrandRequest can have this status. If no records have this status (initial csv upload) - default to first record */
    SELECTED: -2
}


// WEBPACK FOOTER //
// ./src/enums.js